import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = () => {
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Transferred',
        data: [65, 59, 80, 81, 56, 55],
        fill: false,
        borderColor: 'rgb(0, 197, 0)',
        tension: 0.1,
      },
      {
        label: 'Rejected',
        data: [55, 46, 60, 62, 44, 42],
        fill: false,
        borderColor: 'rgb(197, 0, 0)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        ticks: {
          color: 'black',
        },
      },
      y: {
        ticks: {
          color: 'black',
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
